import {createSlice, PayloadAction} from '@reduxjs/toolkit'

type NavigationState = {
    title: string
}
const initialState: NavigationState = {
    title: ""
}

export const init_session = () => ({type: "session/init_session"})

const navSlice = createSlice({
    name: "nav",
    initialState,
    reducers: {
        setTitle: (state, action: PayloadAction<string>) => {
            state.title = action.payload
        }
    },
});

export const {
    setTitle
} = navSlice.actions
export const reducer = navSlice.reducer;




